import React from 'react'
import { LifebuoyIcon } from '@heroicons/react/24/outline'

export const EmergencyDepartmentToolkit: React.FC = () => {
  const toolkitLinks: { label: string; href: string }[] = [
    {
      label: 'Cover Letter',
      href: 'https://www.dropbox.com/scl/fi/7360a5oa6j04m6l4g5fdl/1-Cover-Letter.pdf?rlkey=mid4jck5n6pr4qbsvg2yc4cbf&st=esjf2l62&dl=0'
    },
    {
      label: 'ED Pain Management Template',
      href: 'https://www.dropbox.com/scl/fi/15gi5xg37q26ffu0lnckb/2-ED-Pain-Management-Template.pdf?rlkey=kuoxga98q7hoywv73gtww85bw&st=csg7or22&dl=0'
    },
    {
      label: 'Core Principles and Best Practices for Treatment of VOE',
      href: 'https://www.dropbox.com/scl/fi/t5apfkd51douxwjmouz3i/3-Core-principles-and-best-practices-for-treatment-of-VOE.pdf?rlkey=ylnjmu48fjofkjx8ezf7ogs0l&st=8smhoruz&dl=0'
    },
    {
      label: 'References',
      href: 'https://www.dropbox.com/scl/fi/r9dmdvpf6d8o6oz8b63n5/4-References.pdf?rlkey=8udbzjknveoou5r2evofmmv35&st=kj720afp&dl=0'
    },
    {
      label: 'SC Comprehensive Medical Center Listing',
      href: 'https://www.dropbox.com/scl/fi/766pdivv5zx4hbd3vbrdw/5-SC-Comprehensive-Med-Ctr-Listing.pdf?rlkey=mevu505nk497ittng60ci4chb&st=7x4w737h&dl=0'
    },
    {
      label: 'SCD Referral Form',
      href: 'https://www.dropbox.com/scl/fi/iioa7bs1rpg900d1pdazm/6-SCD-Referral-Form.pdf?rlkey=isakqs82lfgvrvn7rj0qy6lud&st=fe02bd9b&dl=0'
    },
    {
      label: 'QI Indicators',
      href: 'https://www.dropbox.com/scl/fi/05zj6lk19aeiq0olh252c/7-QI-Indicators.pdf?rlkey=stvgkmf4x2juq1kkp4xmexcf1&st=2ootckyh&dl=0'
    },
    {
      label: 'Weight Based Opioid and NSAID Doses',
      href: 'https://www.dropbox.com/scl/fi/6mmnl12ftuzecjck9echd/8-Weight-Based-Opioid-and-NSAID-Doses.pdf?rlkey=v1ng5aitx5ejg43imk5ddffxy&st=elo6kwa8&dl=0'
    },
    {
      label: 'Individualized Dosing Determination Guidelines',
      href: 'https://www.dropbox.com/scl/fi/1qhq1c1y6b1jr0bn3xw8z/9-Individualized-Dosing-Determination-Guidelines.pdf?rlkey=87qijl70fugzqzh9kza6icvi5&st=smuk5kpy&dl=0'
    },
    {
      label: 'Signatures',
      href: 'https://www.dropbox.com/scl/fi/2lpf03h0vulbdl30norl7/10-Signatures.pdf?rlkey=b1ws2ey75vpurxn5xat1wtizc&st=t62d4o9k&dl=0'
    },
    {
      label: 'Toolkit Contributors Acknowledgement',
      href: 'https://www.dropbox.com/scl/fi/vd04wrbydjs0zetvwg32j/11-Toolkit-Contributors-Acknowledgement.pdf?rlkey=7rp5gkk25yzplmxqnnlk75n7t&st=i9lg51yr&dl=0'
    }
  ]

  return (
    <main className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <header className="mb-12">
          <h1 className="text-4xl md:text-5xl font-serif text-[#3C2416] mb-4">
            Emergency Department Toolkit
          </h1>
          <div className="space-y-4 text-lg text-[#3C2416]">
            <p>
              In 2022, The Governor&apos;s North Carolina Appointed Council on
              Sickle Cell Disease and Related Blood Disorders Medical Research
              Committee and colleagues across the state identified the need to
              improve the treatment of SCD pain in emergency departments across
              NC.
            </p>
            <p>
              To meet this goal, the committee, including ED and SCD experts as
              well as community based organizations and representatives from the
              NC Sickle Cell Program, Division of Public Health, Infant and
              Community Health Branch, developed a toolkit including the
              following resources:
            </p>
            <ol className="list-decimal pl-6 space-y-1 text-[#3C2416]">
              <li>
                Template for Emergency Department Management of Acute Sickle
                Cell Pain - Evidence Based Standard of Care
              </li>
              <li>
                Core principles and best practices for treatment of
                vaso-occlusive episodes (VOE) in the ED
              </li>
              <li>
                Links to references used for the development of these templates
                and guidelines
              </li>
              <li>
                List of and contacts for Comprehensive Sickle Cell Medical
                Centers in NC
              </li>
              <li>
                Sickle Cell Disease Referral Form: NC Sickle Cell Syndrome
                Program
              </li>
              <li>Suggested indicators for quality improvement</li>
              <li>
                Weight based opioid charts for pediatric and adult patients
              </li>
              <li>Individualized dosing determination guidelines</li>
            </ol>
            <p>
              The overall goal of the toolkit is to support efforts in EDs
              across the state to implement evidence-based pain management
              guidelines to manage pain and decrease the rates of admissions.
            </p>
            <p>
              EDs with the highest number of visits for SCD in NC were
              identified, ranked, and those with the highest number of ED SCD
              visits were prioritized to receive the toolkit first. The toolkit
              was disseminated via email to the CEO or President of the
              hospital, as well as to the ED Medical and Nursing Directors. Each
              hospital was asked to provide a local champion and contact which
              an ED and SCD expert member of the council would reach out to and
              assist with implementation.
            </p>
            <p>
              Each ED and SCD expert consultant worked with each site to:
              develop an ED/SCD team, identify team members, identify quality
              improvement targets, review evidence based recommendations for
              treatment of VOC, discuss barriers to implementation, and provide
              successful strategies.
            </p>
            <p>
              This toolkit can be modified to help with an individual
              center&apos;s needs.
            </p>
            <p className="font-semibold text-[#3C2416]">
              Developed by: Governor&apos;s North Carolina Appointed Council on
              Sickle Cell Disease and Related Blood Disorders Medical Research
              Committee (2024)
            </p>
          </div>
        </header>

        <section className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="flex justify-between items-center p-6">
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-8 h-8 text-[#A6410A]">
                <LifebuoyIcon className="w-6 h-6" />
              </div>
              <h2 className="text-xl text-[#A6410A] font-medium">
                Toolkit Resources
              </h2>
            </div>
          </div>

          <div className="px-6 pb-6">
            <p className="text-[#3C2416] mb-4">
              Click any resource below to download the corresponding PDF.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-6 mt-2">
              {toolkitLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-200 border border-gray-100 hover:border-[#A6410A] group text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h3 className="text-[#A6410A] text-base font-semibold leading-snug">
                    {link.label}
                  </h3>
                </a>
              ))}
            </div>
          </div>
        </section>
      </div>
    </main>
  )
}
